import api from './api';

export const getSubscriptionStatus = () => api.get('/subscription/status');
export const createCheckout = (interval) => api.post('/subscription/create-checkout', { interval });
export const createPortal = () => api.post('/subscription/create-portal');
